import axios from "axios";
import { GET_PATIENT_MASTER_URL } from "api/resources/configs/URL";
import { parseResponse } from "api/resources/handlers/parseResponse/parseResponse";
import { getRequestOptions } from "api/resources/configs/requests";
import { GetPatientMasterProfileResponsePayload } from "./getPatientMasterProfile.fromApi.types";
import { formatGetPatientMasterProfileErrorMessage } from "api/resources/messages/ErrorMessage";

export const getPatientMasterProfile = async (
  myInfoName: string | null,
  myInfoDoB: string | null,
  myInfoSex: string | null,
  uuid: string | null | undefined,
  codeVerifier: string | null,
): Promise<GetPatientMasterProfileResponsePayload> => {
  try {
    const response = await axios.post<GetPatientMasterProfileResponsePayload>(
      GET_PATIENT_MASTER_URL(),
      createRequestPayload(
        myInfoName,
        myInfoDoB,
        myInfoSex,
        uuid,
        codeVerifier,
      ),
      getRequestOptions(),
    );
    return parseResponse(response, GET_PATIENT_MASTER_URL(), true);
  } catch (error) {
    const msg = formatGetPatientMasterProfileErrorMessage(
      GET_PATIENT_MASTER_URL(),
    );
    console.error(msg);
    throw error;
  }
};

const createRequestPayload = (
  myInfoName: string | null,
  myInfoDoB: string | null,
  myInfoSex: string | null,
  uuid: string | null | undefined,
  codeVerifier: string | null,
) => {
  return {
    MyInfoName: myInfoName,
    MyInfoDoB: myInfoDoB,
    MyInfoSex: myInfoSex,
    UserId: uuid,
    CodeVerifier: codeVerifier,
  };
};
